import { Controller, MainMenu, Menu, Toolbar } from '@tencent/workbench';
import { INSERT_TEXT_MENU_CONFIGS, config, ALIGN_TOOLBAR_CONFIGS } from './config';
import React from 'react';
import { wrapIdForBig, wrapIdForCommon, wrapIdForText } from '@framework/workbench/util/wrap-id-util';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: ALIGN_TOOLBAR_CONFIGS,
})
export class AlignController {
    constructor() {
    }

    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    @Toolbar(wrapIdForCommon(config.id), 'dropdownContent')
    public getAlignBigMenu() {
        return <MainMenu
            align="left" name={wrapIdForBig(config.id)} mode="menu" itemStyle={{ width: 166 }} />;
    }
}
